<template>
    <div
        role="status"
        class="animate-pulse min-h-[1rem] bg-neutral-200 dark:bg-neutral-700 border-neutral-250 dark:border-neutral-750 border-b last:border-b-none w-full" />
</template>